import * as types from "./ActionTypes";
import Api from "../api/UserApi";
import UrlHelper from "../utilities/UrlHelper";

export const resetPassword = (id, login) => {
    return (dispatch) => {
        return Api.resetPassword(id)
            .then((data) => {
                dispatch({ type: types.RESET_USER_PASSWORD_SUCCEEDED, newPassword: data, login: login });
            })
            .catch((error) => {
                dispatch({ type: types.RESET_USER_PASSWORD_FAILED, error });
                throw(error);
            });
    };
};

export const getUserByLogin = (siteId, login) => {
    return (dispatch) => {
        return Api.getUserByLogin(siteId, login)
            .then((user) => {
                if (user.IsLocked) {
                    dispatch({ type: types.USER_LOCKED, isUserLocked: true, userId: user.Id });
                } else {
                    dispatch({ type: types.GET_USER_BY_LOGIN_SUCCEEDED, user });
                }
                return user;
            })
            .catch((error) => {
                dispatch({ type: types.GET_USER_BY_LOGIN_FAILED, error });
                throw(error);
            });
    };
};

export const unlockUser = (userId) => {
    return (dispatch) => {
        return Api.unlock(userId)
            .then(() => {
                return dispatch({ type: types.USER_UNLOCKED_SUCCEEDED, userId: userId });
            })
            .catch((error) => {
                dispatch({ type: types.USER_UNLOCKED_FAILED, error });
                throw(error);
            });
    };
};

export const getCurrentUser = () => {
    return (dispatch) => {
        return Api.getCurrentUser()
            .then((result) => {
                return dispatch({ type: types.GET_CURRENT_USER_SUCCEEDED, user: result.User });
            })
            .catch((error) => {
                dispatch({ type: types.GET_CURRENT_USER_FAILED, error });
                throw(error);
            });
    };
};

export const getUserById = (userId) => {
    return (dispatch) => {
        return Api.getUserById(userId)
            .then((result) => {
                return dispatch({ type: types.GET_USER_BY_ID_SUCCEEDED, user: result });
            })
            .catch((error) => {
                dispatch({ type: types.GET_USER_BY_ID_FAILED, error });
                throw(error);
            });
    };
};

export const changePassword = (newPassword, currentPassword, userId) => {
    return (dispatch) => {
        return Api.changePassword(newPassword, currentPassword, userId)
            .then(() => {
                dispatch({ type: types.CHANGE_USER_PASSWORD_SUCCEEDED });
            })
            .catch((error) => {
                dispatch({ type: types.CHANGE_USER_PASSWORD_FAILED, error });
                throw(error);
            });
    };
};

export const ssoLinkUser = (site, login, password, ticket) => {
    return (dispatch) => {
        return Api.ssoLinkUser(site, login, password, ticket)
            .then((res) => {
                dispatch({ type: types.LINK_USER_SUCCEEDED, url: res.Url });
            })
            .catch((error) => {
                dispatch({ type: types.LINK_USER_FAILED, error });
                //throw(error);
            });
    };
};

export const changePasswordAndLogin = (request) => {
    return (dispatch) => {
        return Api.changePasswordAndLogin(request)
            .then((response) => {
                dispatch({ type: types.CHANGE_USER_PASSWORD_AND_LOGIN_SUCCEEDED, url: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.CHANGE_USER_PASSWORD_AND_LOGIN_FAILED, error });
                throw(error);
            });
    };
};

export const ssoStartLogin = (siteId) => {
    return (dispatch) => {
        return Api.ssoStartLogin(siteId)
            .then((response) => {
                const redirectLocation = getCompleteExternalLoginUrl(response.ExternalLoginUrl);
                dispatch({ type: types.START_SSO_LOGIN_SUCCEEDED, url: redirectLocation });
            })
            .catch((error) => {
                dispatch({ type: types.START_SSO_LOGIN_FAILED, error });
                throw(error);
            });
    };
};

export const startLogin = (siteId, userId, password, product, returnUrl) => {
    return (dispatch) => {
        return Api.startLogin(siteId, userId, password, product, returnUrl)
            .then((response) => {
                dispatch({ type: types.START_LOGIN_SUCCEEDED, url: response.Url });
            })
            .catch((error) => {
                dispatch({ type: types.START_LOGIN_FAILED, error });
                throw(error);
            });
    };
};

export const resendUserSetPasswordEmail = (email) => {
    return (dispatch) => {
        return Api.resendUserSetPasswordEmail(email).then(() => {
            dispatch({ type: types.RESEND_USER_SETPASSWORD_EMAIL_SUCCEEDED });
        })
            .catch((error) => {
                dispatch({ type: types.RESEND_USER_SETPASSWORD_EMAIL_FAILED, error });
                throw(error);
            });
    };
};

const getCompleteExternalLoginUrl = (pingFederateUrl) => {
    var targetUrl = UrlHelper.getIdentifiUrl() + 'AuthActions/CompleteSsoLogin' + UrlHelper.parseUrl().search;
    return pingFederateUrl + '&TargetResource=' + encodeURIComponent(targetUrl);
};
